<template>
  <component :is="getIcon" class="v-svg-icon"
             :viewBox="computedViewBox"
             :style="{ width: size || tag, height: size || tag}"
             @click="$emit('click')"/>
</template>
<script>

export default {
  name: "VSvgIcon",
  deprecated: 'The use of this component is discouraged, you can load svg files using the vue-svg-loader package',
  props: {
    tag: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: function () {
        return this.tag
      }
    },
    viewBox: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    getIcon() {
      return require(`@/assets/images/svg/icons-${this.tag}/${this.icon}.svg`);
    },
    computedViewBox() {
      return this.viewBox || this.defaultViewBox
    },
    defaultViewBox() {
      return `0 0 ${this.tag} ${this.tag}`
    },
  }
};
</script>

<style lang="scss" scoped>
.v-svg-icon {
  display: inline-flex;
  vertical-align: middle;
  overflow: initial;
}
</style>










